/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const accountMemberUpdateSchema = z.object({
      "email": z.string().email(),
  "firstName": z.string().optional(),
  "lastName": z.string().optional(),
  "fonction": z.string().optional(),
  "organizations": z.array(z.string()).describe("Liste des IDs des organisations dont l'utilisateur est membre").optional(),
  "isAdmin": z.boolean().describe("Indique si le membre doit avoir le rôle administrateur").optional(),
  "permissions": z.array(z.string()).describe("Liste des permissions associées à l'utilisateur").optional()
      })